import { Component, OnInit } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { SystemUserAccount } from "../../shared/models/system-user-account.model";
import { SystemUserAccountService } from "../../shared/services/system-user-account.service";
import { SigningAgentDesignationAccount } from "../../shared/models/signing-agent-designation-account.model";
import { SigningAgentDesignationService } from "../../shared/services/signing-agent-designation.service";
import { AddSystemUserModalComponent } from "./add-system-user-modal/add-system-user-modal.component";
import { AddSigningAgentDesignationModalComponent } from "./add-signing-agent-designation-modal/add-signing-agent-designation-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppSpinnerModule } from "src/app/shared/modules/app-spinner.module";
import { SupportUsersTab } from "../models/support-users-tab";

@UntilDestroy()
@Component({
    selector: 'manage-system-users',
    templateUrl: './manage-system-users.component.html',
    styleUrls: ['./manage-system-users.component.scss'],
    standalone: false
})
export class ManageSystemUsersComponent implements OnInit {
  systemUserAccounts: SystemUserAccount[] = [];
  clientUserAccounts: any[] = [];  // replace 'any' with the correct model/interface for client accounts
  designationAccounts: SigningAgentDesignationAccount[] = [];
  filteredUserList: (SystemUserAccount[] | SigningAgentDesignationAccount[] | any[]); // replace 'any' with the correct model/interface for client accounts
  activeTab: SupportUsersTab = 'client';
  designationLoadFailed = false;

  constructor(
    private readonly systemUserAccountService: SystemUserAccountService,
    private readonly designationService: SigningAgentDesignationService,
    private readonly modalService: NgbModal,
    private readonly spinner: AppSpinnerModule,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.getSystemUserAccountList();
  }

  get activeUserList(): (SystemUserAccount[] | SigningAgentDesignationAccount[] | any[]) {
    switch (this.activeTab) {
      case 'system':
        return this.systemUserAccounts;
      case 'designation':
        return this.designationAccounts;
      default:
        return this.clientUserAccounts;
    }
  }

  onFilteredUserList(filteredUsers: (SystemUserAccount[] | SigningAgentDesignationAccount[] | any[])) {
    this.filteredUserList = filteredUsers;
  }

  onSystemAccountDeleted(): void {
    this.getSystemUserAccountList();
  }

  onSystemAccountAdded(): void {
    this.getSystemUserAccountList();
  }

  getSystemUserAccountList(): void {
    this.systemUserAccountService.getAllSystemAccountUsers()
      .subscribe(accounts => {
          this.systemUserAccounts = accounts;
          this.spinner.hide();
      });
  }

  onDesignationsChanged(): void {
    this.getDesignationAccountList();
  }

  getDesignationAccountList(): void {
    this.spinner.show();
    this.designationService.getAllDesignationAccounts()
      .subscribe({
        next: accounts => {
          this.designationAccounts = accounts;
          this.designationLoadFailed = false;
          this.spinner.hide();
        },
        error: () => {
          this.designationAccounts = [];
          this.designationLoadFailed = true;
          this.spinner.hide();
          this.toastr.error("Unable to load signing agent designations.");
        }
      });
  }

  onTabChange(tab: SupportUsersTab) {
    if (tab === this.activeTab) {
      return;
    }

    this.activeTab = tab;
    this.filteredUserList = this.activeUserList;

    if (tab === 'designation') {
      this.getDesignationAccountList();
    }
  }

  openAddSystemUserModal(): void {
    const modalRef = this.modalService.open(AddSystemUserModalComponent, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });

    modalRef.result.then((result) => {
      if (result === "systemAccountAdded") {
        this.onSystemAccountAdded();
      }
    });
  }

  openAddDesignationModal(): void {
    const modalRef = this.modalService.open(AddSigningAgentDesignationModalComponent, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });

    modalRef.result.then((result) => {
      if (result === "designationsAdded") {
        this.onDesignationsChanged();
      }
    });
  }
}
